export default "__VITE_ASSET__Bo2VzaCP__"